module.exports = __webpack_public_path__ + "img/logo-stand-by-you.e32fd0e8.svg";